export default __webpack_public_path__ + "static/media/effects2(2021).d453be48.xlsx";